// extracted by mini-css-extract-plugin
export var story__heroContainer = "storyHero-module--story__heroContainer--yRA3C";
export var story__heroImage = "storyHero-module--story__heroImage--srcP0";